import { render, staticRenderFns } from "./SearchTutor.vue?vue&type=template&id=09dc2e20&scoped=true"
import script from "./SearchTutor.vue?vue&type=script&lang=ts"
export * from "./SearchTutor.vue?vue&type=script&lang=ts"
import style0 from "./SearchTutor.vue?vue&type=style&index=0&id=09dc2e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dc2e20",
  null
  
)

export default component.exports